





























import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import Zone from '@/dto/Zone/Zone'
import ZoneItem from '@/dto/Zone/ZoneItem'
import zoneStore from '@/stores/ZoneStore'
import DeleteBtn from '@/components/delivery/zones/DeleteBtn.vue'

@Component({
  components: { DeleteBtn },
})
export default class ZonesTableRow extends Vue {
  @Prop(Object)
  model: Zone

  @Prop(Object)
  props: any

  zoneName: string = ''
  isPending: boolean = false
  zoneStore = zoneStore

  created() {
    this.zoneName = this.model.name
  }

  async updateZone() {
    const model = Object.assign({}, this.model)
    model.name = this.zoneName
    this.isPending = true
    const zone = await this.zoneStore.updateZone(model)
    this.isPending = false

    if (zone) {
      this.model.name = zone.name
    } else {
      this.zoneName = this.model.name
    }
  }

  showZoneItems() {
    this.zoneStore.selectZone(this.model.id)
  }

  get countriesLabel(): string {
    const items = this.model.items

    if (items.length === 0) {
      return ''
    }

    if (items.length === 1) {
      return items[0].country.name
    }

    const firstItem: ZoneItem = items[0]
    const lastItem: ZoneItem = items[items.length - 1]

    return `${firstItem.country.name}...${lastItem.country.name}`
  }

  get termsLabel(): string {
    if (this.model.items.length === 0) {
      return ''
    }

    return `${this.minTerm}...${this.maxTerm} дн.`
  }

  get termsAsArray(): number[] {
    return this.model.items.reduce(
      (result: number[], item) => [...result, item.minTerm, item.maxTerm],
      []
    )
  }

  get minTerm(): number {
    return Math.min(...this.termsAsArray)
  }

  get maxTerm(): number {
    return Math.max(...this.termsAsArray)
  }
}
